import axios from "axios";
import { apiRoot } from "@/config";

export const list = async () => await axios.get(`${apiRoot}/entities?loggable=true`);
export const create = async entity => await axios.post(apiRoot + "/entities", entity);
export const update = async ({ id, data }) => await axios.post(apiRoot + "/entities/" + id, data);
export const getFromCode = async (code) => await axios.get(apiRoot + "/tasks/share-codes/" + code);